export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const INVMGMT_SERVICE_URL = process.env.REACT_APP_INVMGMT_SERVICE_URL;
export const ORDERS_SERVICE_URL = process.env.REACT_APP_ORDERS_SERVICE_URL;
export const LEAD_SERVICE_URL = process.env.REACT_APP_LEAD_SERVICE_URL;
export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;
export const API_GATEWAY_ID_PROD_SERVICE =
  process.env.REACT_APP_API_GW_ID_PROD_SERVICE;
export const API_GATEWAY_ID_CUSTOMER_SERVICE =
  process.env.REACT_APP_API_GW_ID_CUSTOMER_SERVICE;
export const API_GATEWAY_ID_ORDER_SERVICE =
  process.env.REACT_APP_API_GW_ID_ORDER_SERVICE ?? "";
export const CLOUDFRONT_ASSET_BASE_URL =
  process.env.REACT_APP_CLOUDFRONT_ASSETS_BASE_URL;
export const REACT_APP_POWERBI_URL = process.env.REACT_APP_POWERBI_URL;
